var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("component conectionlessWrap " + (_vm.isNight ? 'conectionlessWrap_dark' : ''))},[_c('img',{staticClass:"connectionless",attrs:{"src":_vm.imgUrl}}),_vm._v(" "),_c('div',{staticClass:"tip"},[_vm._v(_vm._s(_vm.tip || _vm.$t('request.tapTopRetry')))]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afd45a68","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/connectionless/index.vue
// module id = null
// module chunks = 